import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../state/reducers/global";
import ModalInsert from "../../components/ModalInsert";
import { useNavigate } from "react-router";
import GenericConfirmInsert from "../../components/GenericConfirmInsert";
import { declineClaim } from "../../../state/reducers/claimDetailsVendor";
import { clearVehicleRegRequest } from "../../../state/reducers/regSearch";
import { setBucketType } from "./../../../state/reducers/toolbar";
import { setActiveConfirmModalOptionsClaims } from "../../../state/reducers/claimDetailsVendor";

const VendorDeclineClaimDecision = ({ claimData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onDeclineClaim = () => {
    dispatch(declineClaim(claimData, navigate));

  
    const type = "claims";
    const data = {
      action: "decline-claim",
    };
  
    dispatch(setActiveConfirmModalOptionsClaims(type, data));
    dispatch(setBucketType("all"));
    dispatch(clearVehicleRegRequest());
  };
  
  const onCancel = () => {
    dispatch(closeModal());
  };

  return (
    <Fragment>
      <ModalInsert>
          <GenericConfirmInsert
            headerText="Are you sure?"
            bodyText="Are you sure you wish to decline this claim?"
            onCancel={onCancel}
            onConfirm={onDeclineClaim}
          />
      </ModalInsert>
    </Fragment>
  );
};

export default VendorDeclineClaimDecision;
